import classNames from 'classnames';
import { useMemo } from 'react';

import { ArticleFragmentFragment, FeaturedArticlesFragmentFragment } from '../../../__generated__/graphql';
import NewsAndInsights from '../../../components/NewsAndInsights';
import { useRouterParams } from '../../../utils/useRouterParams';

import style from './featured-articles.module.css';

interface FeaturedArticlesProps {
  featuredArticles: FeaturedArticlesFragmentFragment[];
}

const defaultCategoryId = 'default';

const FeaturedArticles = ({
  featuredArticles,
}: FeaturedArticlesProps) => {
  const { categoryId = defaultCategoryId } = useRouterParams();

  const normalizedFeaturedArticles = useMemo(() => {
    return featuredArticles.map(fragment => {
      const articles = (fragment.articles?.flatMap(item => {
        return item?.article?.edges.map(edge =>
          edge.node) ?? [];
      }) ?? []) as ArticleFragmentFragment[];

      const currentCategoryId = fragment.category?.edges[0]?.node.databaseId ?? defaultCategoryId;

      return {
        articles,
        currentCategoryId,
      };
    });
  }, [featuredArticles]);

  return (
    <div className={style.featuredArticles}>
      {normalizedFeaturedArticles.map(({ articles, currentCategoryId }) => {
        return (
          <div
            className={classNames(
              style.newsAndInsightsContainer,
              {
                [style.currentNewsContainer]: currentCategoryId.toString() === categoryId,
              },
            )}
            key={currentCategoryId}
          >
            <NewsAndInsights
              articleLinkText="Read more"
              articles={articles}
              sectionId={null}
              sectionTitle={null}
            />
          </div>
        );
      })}
    </div>
  );
};

export default FeaturedArticles;
